import React, { useState } from 'react';
import Popover from '@mui/material/Popover';
import classNames from 'classnames';
import Typography from '@mui/material/Typography';
import {
  Info as InfoIcon,
} from '@mui/icons-material';

import css from './ToolTip.module.css';

export default function ToolTip(props) {
  const {
    content,
    tip,
    isSuperScript = false,
  } = props || {};
  const [anchorEl, setAnchorEl] = useState(null);

  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  const rootClassName = isSuperScript ? classNames(css.superScript, props.rootClassName || null) : props.rootClassName;

  return (
    <span className={rootClassName}>
      {
        content ? (
          <Typography
            aria-owns={open ? 'mouse-over-popover' : undefined}
            aria-haspopup="true"
            onMouseEnter={handlePopoverOpen}
            onMouseLeave={handlePopoverClose}
          >
            {content}
          </Typography>
        ) : (
          <InfoIcon
            className={css.infoIcon}
            onMouseEnter={handlePopoverOpen}
            onMouseLeave={handlePopoverClose}
            sx={{ fontSize: '1.1rem' }}
          />
        )
      }
      <Popover
        id="mouse-over-popover"
        sx={{ pointerEvents: 'none' }}
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        onClose={handlePopoverClose}
        disableRestoreFocus
      >
        <Typography sx={{ fontSize: '0.85rem', padding: 1 }}>{tip}</Typography>
      </Popover>
    </span>
  );
};
